import {Controller} from "stimulus"
import Rails from "@rails/ujs"

export default class extends Controller {
  static targets = ["content", "field", "form", "feedback"]; // Declare targets including form and feedback

  connect() {
    console.log("ToggleController is connected");

    if (this.fieldTarget.checked === false) {
      this.contentTarget.classList.add("d-none"); // Hide the field initially
    }

    // Add event listeners for form submission
    this.formTarget.addEventListener("ajax:success", this.handleSuccess.bind(this));
    this.formTarget.addEventListener("ajax:error", this.handleError.bind(this));
  }

  toggle(event) {
    const isChecked = event.target.checked; // Check if the switch is toggled on
    if (isChecked) {
      this.contentTarget.classList.remove("d-none"); // Show the field
    } else {
      this.contentTarget.classList.add("d-none"); // Hide the field
    }

    event.preventDefault();

    // Submit the form when toggle is clicked
    this.formTarget.requestSubmit();
  }

  handleSuccess(event) {
    console.log("Success", event.detail);

    // Reset opacity to ensure a clean start
    this.feedbackTarget.style.opacity = '0';

    // Set opacity to 1 to trigger fade-in after a small delay
    setTimeout(() => {
      this.feedbackTarget.style.opacity = '1';
    }, 50);

    // Fade out after 3 seconds
    setTimeout(() => {
      this.feedbackTarget.style.opacity = '0';
    }, 2000);
  }

  handleError(event) {
    console.error("Fail", event.detail);
    // You can add error handling UI feedback here
  }
}
